import { createContext } from "react";

interface OverlayInterface {
  isOverlay: boolean;
  setOverlay: Function;
}

export const OverlayContext = createContext({} as OverlayInterface);